import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";

import ContentView from "./ContentView";
import SlideView from "./SlideView";
import VideoView from "./VideoView";
import NotionView from "./NotionView";
import Header from "../Header";

export default function DetailView({ data }: { data: any }) {
  const nav = useNavigate();
  const onClickBack = () => {
    nav(-1);
  };
  console.log(data);
  const [contentType, setContentType] = useState<
    "Content" | "Video" | "Slide" | "Notion"
  >("Content");
  useEffect(() => {
    if (data?.content_type.includes("video")) {
      setContentType("Video");
    } else if (data?.content_type.includes("slide")) {
      setContentType("Slide");
    } else if (data?.content_type.includes("notion")) {
      setContentType("Notion");
    } else {
      setContentType("Content");
    }
  }, [data?.content_type]);

  return (
    <div className="min-h-screen bg-gray-50 pb-16">
      <Header />
      {/* 외부 링크 버튼 영역 */}
      {(data?.notion_url || data?.github_url) && (
        <div className="flex justify-end items-center gap-3 max-w-3xl mx-auto mt-2">
          {data?.notion_url && (
            <a
              href={data.notion_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded transition border border-gray-200 shadow-sm"
              style={{ minWidth: 40 }}
            >
              <img
                src="/notion_logo.png"
                alt="Notion"
                className="w-5 h-5 mr-2"
              />
              <span className="text-sm font-medium text-gray-700">Notion</span>
            </a>
          )}
          {data?.github_url && (
            <a
              href={data.github_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded transition border border-gray-200 shadow-sm"
              style={{ minWidth: 40 }}
            >
              <img
                src="/github_logo.png"
                alt="GitHub"
                className="w-5 h-5 mr-2"
              />
              <span className="text-sm font-medium text-gray-700">GitHub</span>
            </a>
          )}
        </div>
      )}
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow p-8 mt-8">
        <div className="flex justify-between items-center mb-8">
          <div className="font-bold text-2xl text-gray-900 truncate">
            {data?.name}
          </div>
          <button
            onClick={onClickBack}
            className="flex items-center text-blue-600 hover:text-blue-800 font-medium px-3 py-1 rounded transition"
            type="button"
          >
            <ChevronLeft size={20} />
            <span className="ml-1">뒤로</span>
          </button>
        </div>
        {contentType === "Video" && (
          <VideoView content={data?.content} youtubeUrl={data?.videoURL} />
        )}
        {contentType === "Slide" && (
          <SlideView content={data?.content} images={data?.images} />
        )}
        {contentType === "Content" && <ContentView content={data?.content} />}
        {contentType === "Notion" && <NotionView content={data?.content} />}
      </div>
    </div>
  );
}
